import { FormInstance } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useGetRole } from "../../../lib/hooks/getRole";
import { useAppDispatch } from "../../../store";
import { updateUser } from "../../../acions/users";
import { updateUserData } from "../../../acions/auth";
import { IOption } from "../../../types/Option";

export const useUpdateUser = (
  form: FormInstance,
  user: any,
  roles: IOption[],
  isSaveClicked: boolean,
  setIsSaveClicked: (value: boolean) => void,
  reloadData: () => void,
) => {
  const [isDataDisabled, setIsDataDisabled] = useState(false);

  const dispatch = useAppDispatch();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [__, _, data] = useGetRole();

  const onSave = useCallback(async () => {
    try {
      const values = await form.validateFields();

      const request = {
        ...values,
        phone: values.phone ? `1${values.phone.replace(/[\s-()]/g, "")}` : null,
      };

      setIsDataDisabled(true);

      const isMe: boolean = data.uid === user?.id;

      await Promise.resolve(
        dispatch(updateUser(request, user?.id, roles, isMe, user?.role)),
      );

      isMe &&
        dispatch(
          updateUserData({
            firstName: request.firstName,
            lastName: request.lastName,
          }),
        );

      setIsSaveClicked(false);
      reloadData();
    } catch {
      setIsDataDisabled(false);
      setIsSaveClicked(false);
    }
  }, [data.uid, dispatch, form, reloadData, roles, setIsSaveClicked, user]);

  useEffect(() => {
    isSaveClicked && onSave();
  }, [isSaveClicked, onSave]);

  return { isDataDisabled };
};
